import { site } from "./site";
import type { Money } from "./shopify/types";

// "$68" in listings, "$68.00" wherever amounts are added up.
export function formatMoney(money: Money, { trimZeros = false }: { trimZeros?: boolean } = {}): string {
  const amount = Number(money.amount);
  const whole = trimZeros && Number.isInteger(amount);
  return new Intl.NumberFormat(site.locale, {
    style: "currency",
    currency: money.currencyCode,
    minimumFractionDigits: whole ? 0 : 2,
    maximumFractionDigits: whole ? 0 : 2,
  }).format(amount);
}

export function sumMoney(amounts: Money[], fallbackCurrency = "USD"): Money {
  return {
    amount: amounts.reduce((sum, m) => sum + Number(m.amount), 0).toFixed(2),
    currencyCode: amounts[0]?.currencyCode ?? fallbackCurrency,
  };
}

export function multiplyMoney(money: Money, quantity: number): Money {
  return { amount: (Number(money.amount) * quantity).toFixed(2), currencyCode: money.currencyCode };
}

export function cn(...parts: (string | false | null | undefined)[]): string {
  return parts.filter(Boolean).join(" ");
}

// "Jane's", "James'"
export function possessive(name: string): string {
  return /s$/i.test(name) ? `${name}'` : `${name}'s`;
}

// Shopify names the only variant of a simple product "Default Title".
export function variantLabel(title: string): string | null {
  return title === "Default Title" ? null : title;
}
